import { Constructor } from './constructor.type';
import { DynamicProperty } from '../decorators/dynamic-property.decorator';

export interface IDynamicPlaceholderMixin {
  placeholder: string;
}
export type DynamicPlaceholderCtor = Constructor<IDynamicPlaceholderMixin>;

export function mixinDynamicPlaceholder<T extends Constructor<{}>>(base: T): DynamicPlaceholderCtor & T {
  class DynamicPlaceholderMixin extends base implements IDynamicPlaceholderMixin {
    @DynamicProperty() placeholder = '';

    constructor(...args: any[]) {
      super(...args);
    }
  }

  return DynamicPlaceholderMixin;
}
